export const routePaths = {
	LANDING: "/",
	LANDING_LOAN: "/loan/",
	PAYROLL: "/payroll/",

	SIGN_UP: "/signup/",
	// LOAN_FORM: "/loan/loanform/",
	// LOAN_VIEW: "/loan/loanview/",
	// APPRAISER_LOGIN: "/appraiser/",
	// HOME_SCREEN: "/appraiser/home/",
	// EDIT_APPLICATION: "/appraiser/home/editloanform/",
	// APPLICATION_FORWARD: "/appraiser/home/fwdapplication/",
	// EDIT_APPLICATION_FORWARD: "/appraiser/home/fwdapplication/editloanform/",

	// BRANCH_MANAGER_LOGIN: "/branchmanager/",
	// BRANCH_MANAGER_HOME: "/branchmanager/homebr/",
	// BR_EDIT_APPLICATION: "/branchmanager/homebr/editloanform/",

	// CREDIT_MANAGER_LOGIN: "/creditmanager/",
	// CREDIT_MANAGER_HOME: "/creditmanager/homecr/",
	// CREDIT_MGR_EDIT_APPLICATION: "/creditmanager/homecr/editloanform/",

	// CEO_LOGIN: "/ceo/",
	// CEO_HOME: "/ceo/homeceo/",
	// CEO_EDIT_APPLICATION: "/ceo/homeceo/editloanform/",

	// MIS_ASSISTANT_LOGIN: "/",
	MIS_ASSISTANT_HOME: "/homemis/",
	MIS_ASSISTANT_EDIT_GRT: "/homemis/editgrtform/",
	MIS_ASSISTANT_EDIT_GROUP: "/homemis/editgroupform/",

	BM_HOME: "/homebm/",
	BM_EDIT_GRT: "/homebm/editgrtform/",
	BM_EDIT_GROUP: "/homebm/editgroupform/",

	CO_HOME: "/homeco/",
	CO_EDIT_GRT: "/homeco/editgrtform/",
	CO_EDIT_GROUP: "/homeco/editgroupform/",

	ADMIN_HOME: "/homeadmin/",
	MANAGE_USER: "/homebm/manageuser/",
}
